import type { UiBranding } from "@blueskydataplatform/shared-ui/theme/ui-branding";
import { useMemo } from "react";

/** Memoized horizontal logo src/alt fields for effects that should not list four separate string deps. */
export function useBrandingHorizontalLogos(branding: UiBranding) {
  const horizontal = branding.logo?.horizontal;
  const lightSrc = horizontal?.light?.src;
  const darkSrc = horizontal?.dark?.src;
  const lightAlt = horizontal?.light?.altText;
  const darkAlt = horizontal?.dark?.altText;

  return useMemo(() => ({ lightSrc, darkSrc, lightAlt, darkAlt }), [lightSrc, darkSrc, lightAlt, darkAlt]);
}
